import {ICollectionItemResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/ICollectionItemResponseInstance'
import {IResourceItemResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IResourceItemResponseInstance'
import {getCollectionResourcePayload} from '@toolify/client/src/modules/collections/functions/getCollectionResourcePayload'
import {areIdsEqual} from '@toolify/client/src/modules/collections/functions/areIdsEqual'

export function findCollectionResourceItem(
  item: ICollectionItemResponseInstance,
  resourceItems: IResourceItemResponseInstance[] = [],
): IResourceItemResponseInstance | undefined {
  const payload = getCollectionResourcePayload(item)
  if(!payload) {
    return undefined
  }
  return resourceItems.find(candidate => {
    const resource = candidate.resourceEntity
    if(resource.resourceType !== payload.resourceType) {
      return false
    }
    return areIdsEqual(resource.resourceId, payload.resourceId) || areIdsEqual(candidate.id, payload.resourceId)
  })
}
